import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { Subject } from 'rxjs';
import { ErrorNavigationService } from '../../mega-exchange/services/error-navigation.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { FmLoadingPageService } from '../../shared/services/fm-loading-page.service';
import { MegasService } from '../services/megas.service';
import { PassDataService } from './pass-data.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyzerDisclosureService {
  public disclosureReq: string[] = [];
  public tempMega = '';
  public disclosureWaDetailsRes: any;
  public disclosureSellerDetailsRes: any;
  public loanPurposeRes: any;
  public propertyTypeRes: any;
  public channelRes: any;
  public occupancyStatusRes: any;
  public numberOfUnitsRes: any;
  public originationYearRes: any;
  public stateRes: any;
  public servicersRes: any;
  public borrowersRes: any;
  public mortgageInsCancelIndRes: any;
  public mortgageInsCoverageRes: any;
  public showtempMegaErrorMessage = false;
  public tempMegaErrorMessage = '';

  public mortgageLoanAmountQuartileRes: any;
  public interestRateQuartileRes: any;
  public netInterestRateCurrentQuartileRes: any;
  public loanTermQuartileRes: any;
  public loanAgeQuartileRes: any;
  public loanToValueQuartileRes: any;
  public combinedLoanToValueQuartileRes: any;
  public borrowerCreditScoreQuartileRes: any;
  public remainingMonthsToMaturityQuartileRes: any;

  public collateralValidatedPoolList: any;
  public collateralValidatedPoolListRes: any;

  public disclosureCallStatus: string[] = [];

  private analyzerDisclosureDataSource = new Subject<any>();
  public analyzerDisclosureSubscription$;

  private analyzerDisclosureDetailsTab500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureDetailsTab500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTab500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTab500ErrorCodeSubscription$;

  private analyzerDisclosureWaDetailsTab500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureWaDetailsTab500ErrorCodeSubscription$;

  private analyzerDisclosureSellerDetailsTab500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureSellerDetailsTab500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabLoanPurpose500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabLoanPurpose500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabOccupancyStatus500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabOccupancyStatus500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabChannel500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabChannel500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabState500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabState500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabPropertyType500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabPropertyType500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabBorrower500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabBorrower500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabInsuranceCancelInd500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabInsuranceCancelInd500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabInsuranceCoverage500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabInsuranceCoverage500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabUnits500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabUnits500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabOriginationYear500ErrorCodeSource = new Subject<any>();
  public analyzerDisclosureStatisticsTabOriginationYear500ErrorCodeSubscription$;

  private analyzerDisclosureStatisticsTabServicerDistribution500ErrorCodeSource =
    new Subject<any>();
  public analyzerDisclosureStatisticsTabServicerDistribution500ErrorCodeSubscription$;

  /*
   * Quartile Error Subscription
   */

  private disclosureStatisticsTabQuartilemortgageLoanAmount500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartilemortgageLoanAmount500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartileinterestRate500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartileinterestRate500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartilenetInterestRateCurrent500ErrorCodeSource =
    new Subject<any>();
  public disclosureStatisticsTabQuartilenetInterestRateCurrent500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartileloanTerm500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartileloanTerm500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartileloanAge500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartileloanAge500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartileloanToValue500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartileloanToValue500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartilecombinedLoanToValue500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartilecombinedLoanToValue500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartileborrowerCreditScore500ErrorCodeSource = new Subject<any>();
  public disclosureStatisticsTabQuartileborrowerCreditScore500ErrorCodeSubscription$;

  private disclosureStatisticsTabQuartileremainingMonthsToMaturity500ErrorCodeSource =
    new Subject<any>();
  public disclosureStatisticsTabQuartileremainingMonthsToMaturity500ErrorCodeSubscription$;

  private disclosurePDFButtonCodeSource = new Subject<any>();
  public disclosurePDFButtonCodeSubscription$;

  private megaService = inject(MegasService);
  private router = inject(Router);
  private passDataService = inject(PassDataService);
  private errorHandlerService = inject(ErrorHandlerService);
  private errorNavService = inject(ErrorNavigationService);
  public fmLoadingPageService = inject(FmLoadingPageService);
  private userService = inject(UserService);

  constructor() {
    this.analyzerDisclosureSubscription$ = this.analyzerDisclosureDataSource.asObservable();
    this.analyzerDisclosureDetailsTab500ErrorCodeSubscription$ =
      this.analyzerDisclosureDetailsTab500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTab500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTab500ErrorCodeSource.asObservable();
    this.analyzerDisclosureWaDetailsTab500ErrorCodeSubscription$ =
      this.analyzerDisclosureWaDetailsTab500ErrorCodeSource.asObservable();
    this.analyzerDisclosureSellerDetailsTab500ErrorCodeSubscription$ =
      this.analyzerDisclosureSellerDetailsTab500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabLoanPurpose500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabLoanPurpose500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabOccupancyStatus500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabOccupancyStatus500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabChannel500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabChannel500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabState500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabState500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabPropertyType500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabPropertyType500ErrorCodeSource.asObservable();

    this.analyzerDisclosureStatisticsTabBorrower500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabBorrower500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabInsuranceCancelInd500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabInsuranceCancelInd500ErrorCodeSource.asObservable();

    this.analyzerDisclosureStatisticsTabInsuranceCoverage500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabInsuranceCoverage500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabUnits500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabUnits500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabOriginationYear500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabOriginationYear500ErrorCodeSource.asObservable();
    this.analyzerDisclosureStatisticsTabServicerDistribution500ErrorCodeSubscription$ =
      this.analyzerDisclosureStatisticsTabServicerDistribution500ErrorCodeSource.asObservable();

    this.disclosureStatisticsTabQuartilemortgageLoanAmount500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartilemortgageLoanAmount500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartileinterestRate500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartileinterestRate500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartilenetInterestRateCurrent500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartilenetInterestRateCurrent500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartileloanTerm500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartileloanTerm500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartileloanAge500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartileloanAge500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartileloanToValue500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartileloanToValue500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartilecombinedLoanToValue500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartilecombinedLoanToValue500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartileborrowerCreditScore500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartileborrowerCreditScore500ErrorCodeSource.asObservable();
    this.disclosureStatisticsTabQuartileremainingMonthsToMaturity500ErrorCodeSubscription$ =
      this.disclosureStatisticsTabQuartileremainingMonthsToMaturity500ErrorCodeSource.asObservable();
    this.disclosurePDFButtonCodeSubscription$ = this.disclosurePDFButtonCodeSource.asObservable();
  }

  public getDisclosure(): void {
    const req: any = {};
    this.disclosureReq = [];
    this.disclosureCallStatus = [];

    this.collateralValidatedPoolListRes =
      this.passDataService.getAnalyzerValidatedCollateralResponse();
    this.collateralValidatedPoolList =
      this.collateralValidatedPoolListRes && this.collateralValidatedPoolListRes.collateralDetails;

    this.collateralValidatedPoolList.forEach((item, _index) => {
      const reqPoolDetails: any = {};
      reqPoolDetails.collateralCUSIP = item.cusip;
      reqPoolDetails.currentFaceAmount = parseInt(item.upbAmountWithFactor, 10).toString();
      this.disclosureReq.push(reqPoolDetails);
    }, this);

    req.collaterals = this.disclosureReq;

    this.megaService.getDisclosureTempMega(req).subscribe({
      next: (data) => this.handleDisclosureTempMegaServiceSuccess(data),
      error: (error) => this.handleDisclosureTempMegaServiceFail(error),
    });
  }

  public handleDisclosureTempMegaServiceSuccess(tempMega: any) {
    this.fmLoadingPageService.isLoaderRequesting.set(false);

    if (tempMega && tempMega.includes('TmpMEGA')) {
      this.showtempMegaErrorMessage = false;
      this.passDataService.setTempMega(tempMega);
      this.getDisclosureWADetailsCall(tempMega);
      this.getDisclosureSellerDetailsCall(tempMega);
      this.getLoanPurposeStatistics(tempMega);
      this.getPropertyTypeStatistics(tempMega);
      this.getChannelStatistics(tempMega);
      this.getOccupancyStatusStatistics(tempMega);

      this.getDisclosureNumberOfUnitsStatistics(tempMega);
      this.getDisclosureOriginationYearStatistics(tempMega);
      this.getStateStatistics(tempMega);
      this.getServicerStatistics(tempMega);
      this.getBorrowerStatistics(tempMega);
      this.getMortgageInsuranceCancelIndicatorStatistics(tempMega);
      this.getMortgageInsuranceCoverageStatistics(tempMega);

      /*
       * make quartile call
       */

      this.getMortgageLoanAmountQuartile(tempMega);
      this.getInterestRateQuartile(tempMega);
      this.getNetInterestRateQuartile(tempMega);
      this.getLoanTermQuartile(tempMega);
      this.getLoanAgeQuartile(tempMega);
      this.getLoanToValueQuartile(tempMega);
      this.getCombinedLoanToValueQuartile(tempMega);
      this.getBorrowerCreditScoreQuartile(tempMega);
      this.getRemainingMonthsToMaturityQuartile(tempMega);
    } else {
      this.getAnalyzerDisclosureDetailsFromService();
      this.analyzerDisclosureDetailsTab500ErrorCodeSource.next('details');
      this.analyzerDisclosureStatisticsTab500ErrorCodeSource.next('statistics');
    }
  }

  public handleDisclosureTempMegaServiceFail(_error: any): void {
    this.getAnalyzerDisclosureDetailsFromService();
    this.analyzerDisclosureDetailsTab500ErrorCodeSource.next('details');
    this.analyzerDisclosureStatisticsTab500ErrorCodeSource.next('statistics');

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getDisclosureWADetailsCall(tempMega: string): void {
    const waReq: any = {};

    waReq.tempMegaCusip = tempMega.toString();
    waReq.detailsCategory = 'one';
    this.tempMega = tempMega;

    this.megaService
      .getDisclosureWADetails(waReq)
      .subscribe({
        next: (data) => this.handleDisclosureWADetailsServiceSuccess(data),
        error: (error) => this.handleDisclosureWADetailsServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('WADetailsFinally'));
  }

  public getDisclosureSellerDetailsCall(tempMega: string): void {
    const sellerReq: any = {};

    sellerReq.tempMegaCusip = tempMega.toString();
    sellerReq.detailsCategory = 'two';

    this.megaService
      .getDisclosureWADetails(sellerReq)
      .subscribe({
        next: (data) => this.handleDisclosureSellerDetailsServiceSuccess(data),
        error: (error) => this.handleDisclosureSellerDetailsServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('SellerDetailsFinally'));
  }

  public handleDisclosureWADetailsServiceSuccess(disclosureWADetails: any) {
    this.disclosureWaDetailsRes = disclosureWADetails && disclosureWADetails.details;
    this.passDataService.setDisclosureWaDetailsRes(this.disclosureWaDetailsRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleDisclosureWADetailsServiceFail(_error: any): void {
    this.passDataService.setDisclosureWaDetailsRes(null);
    this.analyzerDisclosureWaDetailsTab500ErrorCodeSource.next('waDetailsError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleDisclosureSellerDetailsServiceSuccess(disclosureSellerDetails: any) {
    this.disclosureSellerDetailsRes = disclosureSellerDetails && disclosureSellerDetails.details;
    this.passDataService.setDisclosureSellerDetailsRes(this.disclosureSellerDetailsRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleDisclosureSellerDetailsServiceFail(_error: any): void {
    this.passDataService.setDisclosureSellerDetailsRes(null);
    this.analyzerDisclosureSellerDetailsTab500ErrorCodeSource.next('sellerDetailsError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public deleteTempMegaCall(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();

    this.megaService.deleteTempMega(req).subscribe({
      next: (data) => this.handleDeleteTempMegaServiceSuccess(data),
      error: (error) => this.handleDeleteTempMegaServiceFail(error),
    });
  }

  public handleDeleteTempMegaServiceSuccess(_deleteRes: any) {
    this.disclosurePDFButtonCodeSource.next('deleteTempMegaResolve');

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleDeleteTempMegaServiceFail(_error: any): void {
    this.disclosurePDFButtonCodeSource.next('deleteTempMegaResolve');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getLoanPurposeStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'loanPurpose';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleLoanPurposeServiceSuccess(data),
        error: (error) => this.handleLoanPurposeServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('LoanPurposeFinally'));
  }

  public handleLoanPurposeServiceSuccess(loanPurposeRes: any) {
    this.loanPurposeRes = loanPurposeRes && loanPurposeRes.statistics;
    this.passDataService.setLoanPurposeRes(this.loanPurposeRes.loanPurpose);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleLoanPurposeServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabLoanPurpose500ErrorCodeSource.next('loanPurposeError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getPropertyTypeStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'propertyType';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handlePropertyTypeServiceSuccess(data),
        error: (error) => this.handlePropertyTypeServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('PropertyTypeFinally'));
  }

  public handlePropertyTypeServiceSuccess(propertyTypeRes: any) {
    this.propertyTypeRes = propertyTypeRes && propertyTypeRes.statistics;
    this.passDataService.setPropertyTypeRes(this.propertyTypeRes.propertyType);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handlePropertyTypeServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabPropertyType500ErrorCodeSource.next('propertyTypeError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getChannelStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'channel';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleChannelServiceSuccess(data),
        error: (error) => this.handleChannelServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('ChannelFinally'));
  }

  public handleChannelServiceSuccess(channelRes: any) {
    this.channelRes = channelRes && channelRes.statistics;
    this.passDataService.setChannelRes(this.channelRes.channel);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleChannelServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabChannel500ErrorCodeSource.next('channelError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getOccupancyStatusStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'occupancyStatus';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleOccupancyStatusServiceSuccess(data),
        error: (error) => this.handleOccupancyStatusServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('OccupancyStatusFinally'));
  }

  public handleOccupancyStatusServiceSuccess(occupancyStatusRes: any) {
    this.occupancyStatusRes = occupancyStatusRes && occupancyStatusRes.statistics;
    this.passDataService.setoccupancyStatusRes(this.occupancyStatusRes.occupancyStatus);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleOccupancyStatusServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabOccupancyStatus500ErrorCodeSource.next(
      'occupancyStatusError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getDisclosureNumberOfUnitsStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'numberOfUnits';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleNumberOfUnitsServiceSuccess(data),
        error: (error) => this.handleNumberOfUnitsServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('NumberOfUnitsFinally'));
  }

  public handleNumberOfUnitsServiceSuccess(numberOfUnitsRes: any) {
    this.numberOfUnitsRes = numberOfUnitsRes && numberOfUnitsRes.statistics;
    this.passDataService.setNumberOfUnitsRes(this.numberOfUnitsRes.numberOfUnits);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleNumberOfUnitsServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabUnits500ErrorCodeSource.next('unitsError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getDisclosureOriginationYearStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'originationYear';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleOriginationYearServiceSuccess(data),
        error: (error) => this.handleOriginationYearServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('OriginationYearFinally'));
  }

  public handleOriginationYearServiceSuccess(originationYearRes: any) {
    this.originationYearRes = originationYearRes && originationYearRes.statistics;
    this.passDataService.setOriginationYearRes(this.originationYearRes.originationYear);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleOriginationYearServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabOriginationYear500ErrorCodeSource.next(
      'originationYearError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getStateStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'state';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleStateServiceSuccess(data),
        error: (error) => this.handleStateServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('StateFinally'));
  }

  public handleStateServiceSuccess(stateRes: any) {
    this.stateRes = stateRes && stateRes.statistics;
    this.passDataService.setStateRes(this.stateRes.state);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleStateServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabState500ErrorCodeSource.next('stateError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getServicerStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'servicers';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleServicerServiceSuccess(data),
        error: (error) => this.handleServicerServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('ServicerFinally'));
  }

  public handleServicerServiceSuccess(servicersRes: any) {
    this.servicersRes = servicersRes && servicersRes.statistics;
    this.passDataService.setServicersRes(this.servicersRes.servicers);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleServicerServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabServicerDistribution500ErrorCodeSource.next(
      'servicerError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getBorrowerStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'borrowers';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleBorrowerServiceSuccess(data),
        error: (error) => this.handleBorrowerServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('BorrowerFinally'));
  }

  public handleBorrowerServiceSuccess(borrowersRes: any) {
    this.borrowersRes = borrowersRes && borrowersRes.statistics;
    this.passDataService.setBorrowersRes(this.borrowersRes.borrowers);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleBorrowerServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabBorrower500ErrorCodeSource.next('borrowerError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getMortgageInsuranceCancelIndicatorStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'mortgageInsCancelInd';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleMortgageInsuranceCancelIndicatorServiceSuccess(data),
        error: (error) => this.handleMortgageInsuranceCancelIndicatorServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('MortgageInsuranceCancelIndicatorFinally'));
  }

  public handleMortgageInsuranceCancelIndicatorServiceSuccess(mortgageInsCancelIndRes: any) {
    this.mortgageInsCancelIndRes = mortgageInsCancelIndRes && mortgageInsCancelIndRes.statistics;
    this.passDataService.setMortgageInsCancelIndRes(
      this.mortgageInsCancelIndRes.mortgageInsCancelInd,
    );
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleMortgageInsuranceCancelIndicatorServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabInsuranceCancelInd500ErrorCodeSource.next(
      'insuranceCancelIndError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getMortgageInsuranceCoverageStatistics(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.statType = 'mortgageInsCoverage';

    this.megaService
      .getStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleMortgageInsuranceCoverageServiceSuccess(data),
        error: (error) => this.handleMortgageInsuranceCoverageServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('MortgageInsuranceCoverageFinally'));
  }

  public handleMortgageInsuranceCoverageServiceSuccess(mortgageInsCoverageRes: any) {
    this.mortgageInsCoverageRes = mortgageInsCoverageRes && mortgageInsCoverageRes.statistics;
    this.passDataService.setMortgageInsCoverageRes(this.mortgageInsCoverageRes.mortgageInsCoverage);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleMortgageInsuranceCoverageServiceFail(_error: any): void {
    this.analyzerDisclosureStatisticsTabInsuranceCoverage500ErrorCodeSource.next(
      'insuranceCoverageError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  /*
   * quartiles call

   */

  public getMortgageLoanAmountQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'mortgageLoanAmount';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleMortgageLoanAmountQuartileServiceSuccess(data),
        error: (error) => this.handleMortgageLoanAmountQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('MortgageLoanAmountQuartileFinally'));
  }

  public handleMortgageLoanAmountQuartileServiceSuccess(mortgageLoanAmountQuartileRes: any) {
    this.mortgageLoanAmountQuartileRes =
      mortgageLoanAmountQuartileRes && mortgageLoanAmountQuartileRes.quartiles;
    this.passDataService.setMortgageLoanAmountQuartileRes(this.mortgageLoanAmountQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleMortgageLoanAmountQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartilemortgageLoanAmount500ErrorCodeSource.next(
      'quartileMortgageLoanAmountError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getInterestRateQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'interestRate';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleInterestRateQuartileServiceSuccess(data),
        error: (error) => this.handleInterestRateQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('InterestRateQuartileFinally'));
  }

  public handleInterestRateQuartileServiceSuccess(interestRateQuartileRes: any) {
    this.interestRateQuartileRes = interestRateQuartileRes && interestRateQuartileRes.quartiles;
    this.passDataService.setInterestRateQuartileRes(this.interestRateQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleInterestRateQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartileinterestRate500ErrorCodeSource.next(
      'quartileInterestRateError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getNetInterestRateQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'netInterestRate_Current';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleNetInterestRateQuartileServiceSuccess(data),
        error: (error) => this.handleNetInterestRateQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('NetInterestRateQuartileFinally'));
  }

  public handleNetInterestRateQuartileServiceSuccess(netInterestRateCurrentQuartileRes: any) {
    this.netInterestRateCurrentQuartileRes =
      netInterestRateCurrentQuartileRes && netInterestRateCurrentQuartileRes.quartiles;
    this.passDataService.setNetInterestRateCurrentQuartileRes(
      this.netInterestRateCurrentQuartileRes,
    );
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleNetInterestRateQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartilenetInterestRateCurrent500ErrorCodeSource.next(
      'quartileNetInterestRateError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getLoanTermQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'loanTerm';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleLoanTermQuartileServiceSuccess(data),
        error: (error) => this.handleLoanTermQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('LoanTermQuartileFinally'));
  }

  public handleLoanTermQuartileServiceSuccess(loanTermQuartileRes: any) {
    this.loanTermQuartileRes = loanTermQuartileRes && loanTermQuartileRes.quartiles;
    this.passDataService.setLoanTermQuartileRes(this.loanTermQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleLoanTermQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartileloanTerm500ErrorCodeSource.next('quartileLoanTermError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getLoanAgeQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'loanAge';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleLoanAgeQuartileServiceSuccess(data),
        error: (error) => this.handleLoanAgeQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('LoanAgeQuartileFinally'));
  }

  public handleLoanAgeQuartileServiceSuccess(loanAgeQuartileRes: any) {
    this.loanAgeQuartileRes = loanAgeQuartileRes && loanAgeQuartileRes.quartiles;
    this.passDataService.setloanAgeQuartileRes(this.loanAgeQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleLoanAgeQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartileloanAge500ErrorCodeSource.next('quartileLoanAgeError');
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getLoanToValueQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'loanToValue';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleLoanToValueQuartileServiceSuccess(data),
        error: (error) => this.handleLoanToValueQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('LoanToValueQuartileFinally'));
  }

  public handleLoanToValueQuartileServiceSuccess(loanToValueQuartileRes: any) {
    this.loanToValueQuartileRes = loanToValueQuartileRes && loanToValueQuartileRes.quartiles;
    this.passDataService.setLoanToValueQuartileRes(this.loanToValueQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleLoanToValueQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartileloanToValue500ErrorCodeSource.next(
      'quartileLoanToValueError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getCombinedLoanToValueQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'combined_LoanToValue';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleCombinedLoanToValueQuartileServiceSuccess(data),
        error: (error) => this.handleCombinedLoanToValueQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('CombinedLoanToValueQuartileFinally'));
  }

  public handleCombinedLoanToValueQuartileServiceSuccess(combinedLoanToValueQuartileRes: any) {
    this.combinedLoanToValueQuartileRes =
      combinedLoanToValueQuartileRes && combinedLoanToValueQuartileRes.quartiles;
    this.passDataService.setCombinedLoanToValueQuartileRes(this.combinedLoanToValueQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleCombinedLoanToValueQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartilecombinedLoanToValue500ErrorCodeSource.next(
      'quartileCombinedLoanToValueError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getBorrowerCreditScoreQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'borrowerCreditScore';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleBorrowerCreditScoreQuartileServiceSuccess(data),
        error: (error) => this.handleBorrowerCreditScoreQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('BorrowerCreditScoreQuartileFinally'));
  }

  public handleBorrowerCreditScoreQuartileServiceSuccess(borrowerCreditScoreQuartileRes: any) {
    this.borrowerCreditScoreQuartileRes =
      borrowerCreditScoreQuartileRes && borrowerCreditScoreQuartileRes.quartiles;
    this.passDataService.setBorrowerCreditScoreQuartileRes(this.borrowerCreditScoreQuartileRes);
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleBorrowerCreditScoreQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartileborrowerCreditScore500ErrorCodeSource.next(
      'quartileBorrowerCreditScoreError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public getRemainingMonthsToMaturityQuartile(tempMega: any): void {
    const req: any = {};

    req.tempMegaCusip = tempMega.toString();
    req.quartilesType = 'remainingMonthsToMaturity';

    this.megaService
      .getQuartileStatisticsDetails(req)
      .subscribe({
        next: (data) => this.handleRemainingMonthsToMaturityQuartileServiceSuccess(data),
        error: (error) => this.handleRemainingMonthsToMaturityQuartileServiceFail(error),
      })
      .add(() => this.disclosureCallsCompleteResolved('RemainingMonthsToMaturityQuartileFinally'));
  }

  public handleRemainingMonthsToMaturityQuartileServiceSuccess(
    remainingMonthsToMaturityQuartileRes: any,
  ) {
    this.remainingMonthsToMaturityQuartileRes =
      remainingMonthsToMaturityQuartileRes && remainingMonthsToMaturityQuartileRes.quartiles;
    this.passDataService.setRemainingMonthsToMaturityQuartileRes(
      this.remainingMonthsToMaturityQuartileRes,
    );
    this.getAnalyzerDisclosureDetailsFromService();

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleRemainingMonthsToMaturityQuartileServiceFail(_error: any): void {
    this.disclosureStatisticsTabQuartileremainingMonthsToMaturity500ErrorCodeSource.next(
      'quartileRemainingMonthsToMaturityError',
    );
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public handleAnalyzerGrid500ErrorCode(error: any): void {
    this.errorHandlerService.setErrorObj(error);
    this.errorNavService.navigateToError500 = true;
    this.router.navigate(['error']);
  }

  public disclosureDetailsReset(): void {
    this.disclosureWaDetailsRes = null;
    this.disclosureSellerDetailsRes = null;
    this.loanPurposeRes = null;
    this.propertyTypeRes = null;
    this.channelRes = null;
    this.occupancyStatusRes = null;
    this.numberOfUnitsRes = null;
    this.originationYearRes = null;
    this.stateRes = null;
    this.servicersRes = null;
    this.borrowersRes = null;
    this.mortgageInsCancelIndRes = null;
    this.mortgageInsCoverageRes = null;

    this.mortgageLoanAmountQuartileRes = null;
    this.interestRateQuartileRes = null;
    this.netInterestRateCurrentQuartileRes = null;
    this.loanTermQuartileRes = null;
    this.loanAgeQuartileRes = null;
    this.loanToValueQuartileRes = null;
    this.combinedLoanToValueQuartileRes = null;
    this.borrowerCreditScoreQuartileRes = null;
    this.remainingMonthsToMaturityQuartileRes = null;
  }

  public getAnalyzerDisclosureDetailsFromService(): any {
    const mBundle: any = {};

    mBundle.disclosureWaDetailsRes = this.disclosureWaDetailsRes;
    mBundle.disclosureSellerDetailsRes = this.disclosureSellerDetailsRes;
    mBundle.loanPurposeRes = this.loanPurposeRes;
    mBundle.propertyTypeRes = this.propertyTypeRes;
    mBundle.channelRes = this.channelRes;
    mBundle.occupancyStatusRes = this.occupancyStatusRes;
    mBundle.numberOfUnitsRes = this.numberOfUnitsRes;
    mBundle.originationYearRes = this.originationYearRes;
    mBundle.stateRes = this.stateRes;
    mBundle.servicersRes = this.servicersRes;
    mBundle.borrowersRes = this.borrowersRes;
    mBundle.mortgageInsCancelIndRes = this.mortgageInsCancelIndRes;
    mBundle.mortgageInsCoverageRes = this.mortgageInsCoverageRes;
    mBundle.mortgageLoanAmountQuartileRes = this.mortgageLoanAmountQuartileRes;
    mBundle.interestRateQuartileRes = this.interestRateQuartileRes;
    mBundle.netInterestRateCurrentQuartileRes = this.netInterestRateCurrentQuartileRes;

    mBundle.loanTermQuartileRes = this.loanTermQuartileRes;
    mBundle.loanAgeQuartileRes = this.loanAgeQuartileRes;
    mBundle.mortgageInsCoverageRes = this.mortgageInsCoverageRes;
    mBundle.loanToValueQuartileRes = this.loanToValueQuartileRes;
    mBundle.combinedLoanToValueQuartileRes = this.combinedLoanToValueQuartileRes;
    mBundle.borrowerCreditScoreQuartileRes = this.borrowerCreditScoreQuartileRes;
    mBundle.remainingMonthsToMaturityQuartileRes = this.remainingMonthsToMaturityQuartileRes;

    this.analyzerDisclosureDataSource.next(mBundle);
  }

  public disclosureCallsCompleteResolved(val: any): any {
    this.disclosureCallStatus.push(val);
    if (this.disclosureCallStatus.length === 22) {
      this.deleteTempMegaCall(this.tempMega);
    }
  }
}
